import { EmployeeEntity, EmployeeFilter } from '../../models'

export const SET_EMPLOYEES = 'SET_EMPLOYEES'
export const SET_EMPLOYEES_LOADED = 'SET_EMPLOYEES_LOADED'
export const SET_EMPLOYEE_FILTER = 'SET_EMPLOYEE_FILTER'
export const SET_SELECTED_EMPLOYEE = 'SET_SELECTED_EMPLOYEE'

export interface EmployeeState {
  employees: EmployeeEntity[]
  isEmployeesLoaded: boolean
  employeeFilter: EmployeeFilter
  selectedEmployee?: EmployeeEntity
}

interface SetEmployeesAction {
  type: typeof SET_EMPLOYEES
  payload: EmployeeEntity[]
}

interface SetEmployeesLoadedAction {
  type: typeof SET_EMPLOYEES_LOADED
  payload: boolean
}

interface SetSelectedEmployeeAction {
  type: typeof SET_SELECTED_EMPLOYEE
  payload?: EmployeeEntity
}

interface SetEmployeeFilterAction {
  type: typeof SET_EMPLOYEE_FILTER
  payload: EmployeeFilter
}

export type EmployeeAction =
  | SetEmployeesAction
  | SetEmployeesLoadedAction
  | SetSelectedEmployeeAction
  | SetEmployeeFilterAction
